// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3WvMm","top":"styles_top__27HJG"};